import { Download } from '@assets/svg';
import IconButton from '@components/IconButton/IconButton';
import Text from '@components/Text/Text';
import { Document as DocumentProps } from '@features/api/response/tabContent/EDocuments';
import { useTheme } from '@mui/material';
import {
  StyledContainer,
  ThumbnailContainer,
  BottomContainer,
  Thumbnail,
} from './Document.styles';

const Document: React.FC<DocumentProps> = ({
  name,
  downloadLink,
  thumbnailLink,
  displayName = name,
}) => {
  const theme = useTheme();

  const downloadFile = (url: string, filename: string) => {
    const req = new XMLHttpRequest();

    req.open('GET', url, true);
    req.responseType = 'blob';
    req.onload = function () {
      const blob = new Blob([req.response], {
        type: 'application/pdf',
      });

      const windowUrl = window.URL || window.webkitURL;
      const href = windowUrl.createObjectURL(blob);
      const a = document.createElement('a');
      a.setAttribute('download', filename);
      a.setAttribute('href', href);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };
    req.onerror = function () {
      window.open(downloadLink);
    };

    req.send();
  };

  return (
    <StyledContainer>
      <ThumbnailContainer
        style={{ cursor: 'pointer' }}
        onClick={() => window.open(downloadLink)}
      >
        <Thumbnail alt='document-thumbnail' src={thumbnailLink} />
      </ThumbnailContainer>
      <BottomContainer>
        <Text
          variant='body'
          fontWeight='fontWeightRegular'
          color={theme.palette.text.primary}
          sx={{ wordBreak: 'break-all' }}
        >
          {displayName}
        </Text>
        {downloadLink ? (
          <IconButton
            onClick={() => downloadFile(downloadLink, name)}
            icon={() => <Download />}
            size='small'
            iconBoxHeight={6}
            iconBoxWidth={23}
          />
        ) : null}
      </BottomContainer>
    </StyledContainer>
  );
};

export default Document;
